import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Mail, Phone, MapPin } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8">
            Impressum
          </h1>

          <Card className="border-0 shadow-xl mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                Angaben gemäß § 5 TMG
              </h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Unternehmen</h3>
                  <p className="text-gray-700">
                    Gravante Solar<br />
                    Am Wammesknopf 6<br />
                    70439 Stuttgart<br />
                    Deutschland
                  </p>
                </div>

                <div className="border-t pt-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Kontakt</h3>
                  <div className="space-y-3">
                    <div className="flex items-center text-gray-700">
                      <Phone className="w-5 h-5 mr-3 text-sky-600" />
                      <span>+49 157 82283963</span>
                    </div>
                    <div className="flex items-center text-gray-700">
                      <Mail className="w-5 h-5 mr-3 text-sky-600" />
                      <span>Buchhaltung@gravante.de</span>
                    </div>
                    <div className="flex items-start text-gray-700">
                      <MapPin className="w-5 h-5 mr-3 mt-0.5 text-sky-600" />
                      <span>Am Wammesknopf 6, 70439 Stuttgart</span>
                    </div>
                  </div>
                </div>

                <div className="border-t pt-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Geschäftsführung</h3>
                  <p className="text-gray-700">
                    Gravante G.
                  </p>
                </div>

                <div className="border-t pt-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
                  </h3>
                  <p className="text-gray-700">
                    Gravante Solar<br />
                    Am Wammesknopf 6<br />
                    70439 Stuttgart
                  </p>
                </div>

                <div className="border-t pt-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    Haftungsausschluss
                  </h3>
                  
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-2">Haftung für Inhalte</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                        nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                        Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                        Tätigkeit hinweisen.
                      </p>
                    </div>

                    <div>
                      <h4 className="font-semibold text-gray-800 mb-2">Haftung für Links</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                        Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                        Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
                        der Seiten verantwortlich.
                      </p>
                    </div>

                    <div>
                      <h4 className="font-semibold text-gray-800 mb-2">Urheberrecht</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                        dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                        der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                        Zustimmung des jeweiligen Autors bzw. Erstellers.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border-t pt-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    Streitschlichtung
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline ml-1">
                      https://ec.europa.eu/consumers/odr
                    </a>
                    <br /><br />
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ImpressumPage;
